import styled from "styled-components";
import type { StyledTrProps } from "@/types/DataTableTypes";

export const Row = styled.div<StyledTrProps>`
  .td:first-child {
    ${(props) =>
      props.$isShowDecoratorColor
        ? `border-left: 5px solid ${props.$decoratorColor || "transparent"}`
        : ""};
    ${(props) => (props.$isShowDecoratorColor ? "padding-left: 0.25rem" : "")};
  }
`;

export const Styles = styled.div`
  /* These styles are suggested for the table fill all available space in its containing element */

  /* These styles are required for a horizontally scrollable table overflow */
  overflow: auto;
  position: relative;

  /* Hide native horizontal scrollbar on table container, use floating scrollbar instead */
  .table-container {
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE/Edge */

    &::-webkit-scrollbar {
      height: 0;
      display: none; /* Chrome/Safari/Opera */
    }
  }

  .full-screen-table {
    background-color: white;
    position: relative;
    z-index: 10;
  }

  .table {
    border-spacing: 0;
    margin-bottom: 60px;
    min-height: 400px;
    &.dynamic {
      min-height: 1px;
    }
    .tbody {
      /* Removed overflow: overlay to prevent double scrollbars - parent Styles handles horizontal scroll */
      position: relative;
      z-index: 1;
    }

    .tr {
      /* Override Bootstrap's .table > :not(caption) > * > * padding on rows */
      padding: 0 !important;

      &.odd {
        background: #f9fafa;
        .td {
          background: #f9fafa;
        }
      }
      &.even {
        background: #fff;
        .td {
          background: #fff;
        }
      }
    }

    .mh-30 {
      min-height: 30px;
      background-color: white;
    }

    .th {
      font-weight: bold;
      border-bottom: 2px solid #f3f5f6;
      padding: 0.5rem;
      background-color: white;

      .resizer {
        display: inline-block;
        width: 10px;
        height: 100%;
        position: absolute;
        right: 0;
        top: 0;
        z-index: 1;
        /* prevents from scrolling while dragging on touch devices */
        touch-action: none;
        border-left: 1px solid #424b59 !important;
        cursor: e-resize !important;
        opacity: 0;

        :hover {
          opacity: 0.5;
        }

        &.isResizing {
          opacity: 0.5;
        }
      }

      .group-header-icon {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background-color: #eff3f4;
      }

      .sortIcon {
        color: grey;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background-color: #eff3f4;
      }

      .sortIconHover {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background-color: #eff3f4;
        opacity: 0;
      }

      &:hover {
        .table-group {
          opacity: 1;
        }

        .sortIcon {
          color: unset;
        }

        .sortIconHover {
          opacity: 1;
        }
      }
      .table-group {
        display: inline-block;
        opacity: 0;
        padding: 0px 0.5rem;
        &.show {
          opacity: 1;
        }

        .table-group-toggle {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background-color: #eff3f4;
        }

        .table-group-menu > .table-group-menu-divider:last-of-type {
          display: none;
        }
      }
    }

    .td {
      word-break: break-word;

      &:hover {
        .cell-filter {
          visibility: visible;
        }
      }
      .cell-filter {
        visibility: hidden;
        transition: visibility 0.25s ease-in-out;
        padding-left: 0.25rem;
        padding-right: 0.25rem;
        touch-action: none;
        cursor: pointer !important;
      }
    }
  }
`;
